<template>
  <div class="data-statistics">
    <div class="data-item" v-for="item in datas" :key="item.icon">
      <div class="data-item__icon">
        <svg aria-hidden="true" slot="icon">
          <use :xlink:href="'#'+item.icon"></use>
        </svg>
      </div>
      <div class="data-item__data">
        <div class="number">
          <span class="number-font-family">{{ getNumber(item.number) }}</span>
          <span class="unit" v-if="item.number !== '- -'">{{ item.unit }}</span>
        </div>
        <div class="title">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBigscreenStatistic } from '@/api/data'

export default {
  data() {
    return {
      datas: [{
        icon: 'iconruzhuyinhangjigou',
        text: '入驻银行机构',
        unit: '家',
        key: 'alreadyOpenBank',
        number: '- -'
      }, {
        icon: 'iconfugaiyinhangwangdianshu',
        text: '覆盖银行网点',
        unit: '家',
        key: 'alreadyOpenNet',
        number: '- -'
      }, {
        icon: 'iconyinhangfabuxindaichanpin',
        text: '银行发布信贷产品',
        unit: '款',
        key: 'bankProductCount',
        number: '- -'
      }, {
        icon: 'iconleijifuwukehucishu',
        text: '累计服务客户次数',
        unit: '次',
        key: 'serveCustomerNum',
        number: '- -'
      }, {
        icon: 'iconleijifuwukehushu',
        text: '累计服务客户数',
        unit: '家',
        key: 'enterpriseCount',
        number: '- -'
      }, {
        icon: 'iconleijijiaoyiliang',
        text: '累计交易量',
        unit: '万',
        key: 'loanAllAmount',
        number: '- -'
      }]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      getBigscreenStatistic().then(res => {
        if (res.data.code === 0) {
          let list = res.data.data
          this.datas.forEach((data) => {
            data.number = list[data.key]
          })
        }
      }).finally(() => {})
    },
    getNumber(x) {
      if (!x && x !== 0) return '- -'
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-statistics {
    box-shadow: 0px 4px 16px 2px #efefef;
    height:fit-content;
    max-width: 1024px;
    margin: 48px auto 23px;
    flex-wrap: wrap;
    @include displayCenter;
    position: relative;
    .data-item {
      display: flex;
      align-items: center;
      background-color: #fff;
      border-radius: 8px;
      width: 320px;
      height: 120px;
      margin: 10px 10px;
      &__icon {
        margin: 0 20px 0 30px;
        svg {
          width: 40px;
        }
      }
      &__data {
        text-align: left;
        .number {
          color: $main-color-deep;
          font-size: 26px;
          line-height: 42px;
          font-weight: 500;
          .unit {
            font-size: 18px;
            line-height: 18px;
          }
        }
        .title {
          color: #333;
          font-size: 18px;
          line-height: 25px;
        }
      }
    }
  }
</style>
